<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="cssLayoutRowSpaceCenter">
  <div class="exhibit-teams-list-container mat-elevation-z8">
    <mat-toolbar class="background">
      <mat-toolbar-row>
        <mat-icon class="mdi-24px" fontIcon="mdi-account-multiple"></mat-icon>
        <p>Exhibit Teams</p>
      </mat-toolbar-row>
      <mat-toolbar-row>
        <mat-form-field class="w-50">
          <mat-label>Search</mat-label>
          <input matInput [(ngModel)]="exhibitTeamFilterString" (keyup)="applyExhibitTeamFilter($event)" #exhibitTeamInput autocomplete="off" />
          @if (exhibitTeamFilterString) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="clearExhibitTeamFilter()">
            <mat-icon class="mdi-24px" fontIcon="mdi-close-circle-outline"></mat-icon>
          </button>
          }
        </mat-form-field>
        <mat-paginator #exhibitTeamPaginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
      </mat-toolbar-row>
    </mat-toolbar>

    <mat-table class="mat-table-exhibit-teams" #table [dataSource]="exhibitTeamDataSource" matSort>
      <ng-container matColumnDef="name">
        <mat-cell *matCellDef="let element">
          @if (element.name !== null) {
          <div>{{ element.shortName }}</div>
          }
          @if (element.name === null) {
          <div>{{ element.id }}</div>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-cell *matCellDef="let element">
          <div class="push-right">
            <button mat-icon-button (click)="addTeamToArticle(element.id)" style="outline: none;"
              title="Add {{ element.name }}" [disabled]="!canEdit">
              <mat-icon class="mdi-24px center-self" fontIcon="mdi-plus-circle-outline"></mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; columns: displayedTeamColumns"></mat-row>
    </mat-table>

    @if (exhibitTeamDataSource.filteredData.length === 0) {
    <div>No results found</div>
    }
  </div>

  <div class="exhibit-article-teams-list-container mat-elevation-z8">
    <mat-toolbar class="background">
      <mat-toolbar-row>
        <mat-icon class="mdi-24px" fontIcon="mdi-account-group"></mat-icon>
        <p>Article Teams</p>
      </mat-toolbar-row>
      <mat-toolbar-row>
        <mat-form-field class="w-50">
          <mat-label>Search</mat-label>
          <input matInput [(ngModel)]="articleTeamFilterString" (keyup)="applyArticleTeamFilter($event)" #articleTeamInput autocomplete="off" />
          @if (articleTeamFilterString) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="clearArticleTeamFilter()">
            <mat-icon class="mdi-24px" fontIcon="mdi-close-circle-outline"></mat-icon>
          </button>
          }
        </mat-form-field>
        <mat-paginator #articleTeamPaginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
      </mat-toolbar-row>
    </mat-toolbar>

    <mat-table class="mat-table-article-teams" #table [dataSource]="articleTeamDataSource" matSort>
      <ng-container matColumnDef="name">
        <mat-cell *matCellDef="let element">
          @if (element.name !== null) {
          <div>{{ element.shortName }}</div>
          }
          @if (element.name === null) {
          <div>{{ element.id }}</div>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-cell *matCellDef="let element">
          <div class="push-right">
            <button mat-icon-button (click)="removeTeamFromArticle(element.id)" style="outline: none;"
              title="Remove {{ element.name }}" [disabled]="!canEdit">
              <mat-icon class="mdi-24px center-self" fontIcon="mdi-minus-circle-outline"></mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; columns: displayedTeamColumns"></mat-row>
    </mat-table>

    @if (articleTeamDataSource.filteredData.length === 0) {
    <div>No results found</div>
    }
  </div>
</div>
